export default __webpack_public_path__ + "static/media/banner2.f352e1c0.jpg";